import { ComponentPropsWithoutRef, forwardRef, useEffect, useRef } from 'react';

import { TextInput } from '@any-ui-react/core';
import classNames from 'classnames';

import { SearchIcon } from '@anyx/shared-icons';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxSearchProps extends ComponentPropsWithoutRef<typeof TextInput> {
  withSearchIcon?: boolean;
}

export const ComboboxSearch = forwardRef<HTMLInputElement, ComboboxSearchProps>(
  ({ className, withSearchIcon = true, ...rest }, ref) => {
    const { classNames: contextClassNames, store } = useComboboxContext();
    const styles = comboboxStyles();
    const internalRef = useRef<HTMLInputElement | null>(null);

    // Auto-focus search input when dropdown opens
    useEffect(() => {
      if (!store?.dropdownOpened) return;

      const timer = setTimeout(() => {
        internalRef.current?.focus();
      }, 10);

      return () => clearTimeout(timer);
    }, [store?.dropdownOpened]);

    return (
      <TextInput
        {...rest}
        ref={(node) => {
          internalRef.current = node;
          if (typeof ref === 'function') {
            ref(node);
          } else if (ref) {
            ref.current = node;
          }
        }}
        className={classNames(styles.search(), contextClassNames?.search, className)}
        leftSection={withSearchIcon ? <SearchIcon className="w-3" /> : undefined}
      />
    );
  }
);
